import { render } from "./CompoStep5.vue?vue&type=template&id=37b19c80"
import script from "./CompoStep5.vue?vue&type=script&lang=js"
export * from "./CompoStep5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__